import React from 'react'
import { Link } from 'react-router-dom'
import axios from '~/data/http/axios'
import Avatar from '~/Common-Objects/Avatar/Avatar'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import CheckBox from '~/Common-Objects/UI/Forms/CheckBox/CheckBox'
import Column from '~/Common-Objects/Grids/Column/Column'
import DataTable1 from '~/Common-Objects/Tables/DataTable1/DataTable1'
import Icons from '~/Common-Objects/UI/Icons/index'
import PagingBlock from '~/Common-Objects/Tables/DataTablePaging/DataTablePaging'
import Row from '~/Common-Objects/Grids/Row/Row'
import Score from '~/Common-Objects/UI/Score'
import Select from '~/Common-Objects/UI/Forms/Select/Select'
import SnackBar from '~/Common-Objects/UI/Notifications/SnackBar/SnackBar'
import SquareChip from '~/Common-Objects/UI/Chips/SquareChip.jsx'
import TextInput from '~/Common-Objects/UI/Forms/TextInput/TextInput'
import { connect } from 'react-redux'
import * as siteMaster from '~/data/actions/siteActions' //now we can use user actions here
import queryString from 'query-string'
import axios2 from 'axios'
import DateTimeFunctions from '~/Classes/dateTimeFunctions'
import NumberFunctions from '~/Classes/numberFormatFunctions'
import PermissionChecker from '~/Classes/permissions'
import { getUserSettings, setUserSettings } from '~/Classes/userSettings'
import AddSubs from './addSubs'
import IncGoTickSubs from './incGoTickSubs'
import Bulk from './bulk'
import i18n from '~/i18n'
import ColumnSelect from '~/Common-Objects/UI/ColumnSelect'

const SELECTED_FIELDS_LIMIT = 15

//CONNECT TO STORE
@connect((store) => {
    return { user: store.user, browser: store.browser, permissionStore: store.permission, account: store.accountMaster }
})
export default class SubscribersComponent extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            allTotal: 0,
            total: 0,
            totalViewed: 0,
            subscribers: [],
            tableData: [],
            segments: [],
            status: '',
            segmentId: undefined,
            customFields: [],
            sources: [],
            source: '',
            page: 0,
            retry: 0,
            mobilePageSize: 15,
            pageSize: 15,
            orderBy: 'emailAddress',
            orderDir: 'ASC',
            searchText: '',
            loadingData: 1,
            writeAccess: true,
            isLoading: true,
            isLoadingSegments: true,
            isLoadingSources: true,
            fieldsFilter: '',
            selectedTags: [],
            selectedLinkTags: [],
            selectedFields: [],
            smsFieldId: this.props.account.accountMaster.options?.smsDefaultField,
            systemFields: [
                { fieldName: 'score', fieldDesc: i18n.t('score') },
                { fieldName: 'status', fieldDesc: i18n.t('status') },
                { fieldName: 'createdAt', fieldDesc: i18n.t('created') },
                { fieldName: 'updatedAt', fieldDesc: i18n.t('lastUpdated') },
                { fieldName: 'lastSendDate', fieldDesc: i18n.t('lastSent') },
                { fieldName: 'lastOpened', fieldDesc: i18n.t('lastOpened') },
                { fieldName: 'lastClicked', fieldDesc: i18n.t('lastClicked') },
                { fieldName: 'lastBounced', fieldDesc: i18n.t('lastBounced') },
                { fieldName: 'tags', fieldDesc: i18n.t('tags') },
                { fieldName: 'source', fieldDesc: i18n.t('source') },
                { fieldName: 'disableOpens', fieldDesc: i18n.t('disableOpens') }
                // { fieldName: 'disableClicks', fieldDesc: i18n.t('disableClicks') }
            ],
            selectedSystemFields: [],
            tags: [],
            tagsFilter: '',
            linkTags: [],
            linkTagsFilter: '',
            settings: null
        }

        this.CancelToken = axios2.CancelToken
        this.source = this.CancelToken.source()
        this.retryTimer = null
        this.firstLoad = true

        this.getAccountMaster = this.getAccountMaster.bind(this)
        this.getCustomFields = this.getCustomFields.bind(this)
        this.getSegments = this.getSegments.bind(this)
        this.getSources = this.getSources.bind(this)
        this.getSubscribers = this.getSubscribers.bind(this)
        this.changePageSize = this.changePageSize.bind(this)
        this.changeSegment = this.changeSegment.bind(this)
        this.addSubs = this.addSubs.bind(this)
        this.changeSearchText = this.changeSearchText.bind(this)
        this.searchKeyPress = this.searchKeyPress.bind(this)
        this.changePage = this.changePage.bind(this)
        this.selectFields = this.selectFields.bind(this)
        this.checkAll = this.checkAll.bind(this)
        this.countChecked = this.countChecked.bind(this)
        this.checkBoxes = this.checkBoxes.bind(this)
        this.reloadAfterTickedAndChanged = this.reloadAfterTickedAndChanged.bind(this)
        this.loadmore = this.loadmore.bind(this)
        this.filterFields = this.filterFields.bind(this)
        this.toggleAllFields = this.toggleAllFields.bind(this)
        this.getTags = this.getTags.bind(this)
        this.selectTag = this.selectTag.bind(this)
        this.getLinkTags = this.getLinkTags.bind(this)
        this.selectLinkTag = this.selectLinkTag.bind(this)
        this.selectTags = this.selectTags.bind(this)
        this.changeSelectedFields = this.changeSelectedFields.bind(this)
    }

    componentDidMount() {
        //see if we have write access to the subscribers
        var writeAccess = PermissionChecker('subscribers', this.props.permissionStore.permissions, 'write')

        getUserSettings().then((s) => {
            if (!s.subscribers) s.subscribers = {}
            let save = false
            if (!s.subscribers.limit && this.props.account.tableLimits?.subscribers) {
                save = true
                s.subscribers.limit = this.props.account.tableLimits.subscribers
            }
            if (!s.subscribers.systemFields && this.props.account.systemFields?.[this.props.account.id]) {
                save = true
                s.subscribers.systemFields = this.props.account.systemFields[this.props.account.id].map(
                    (f) => f.fieldName
                )
            }
            if (!s.subscribers.fields && this.props.account.fields?.[this.props.account.id]) {
                save = true
                s.subscribers.fields = this.props.account.fields[this.props.account.id]
            }
            if (save) setUserSettings(s).catch(console.log)
            const obj = {
                settings: s,
                selectedSystemFields: s.subscribers.systemFields
                    ? this.state.systemFields
                          .filter((f) =>
                              s.subscribers.systemFields.some((s) => {
                                  if (typeof s === 'string') {
                                      return s === f.fieldName
                                  } else {
                                      return s.fieldName === f.fieldName
                                  }
                              })
                          )
                          .map((f) => f.fieldName)
                    : [...this.state.systemFields.map((f) => f.fieldName)],
                selectedFields: s.subscribers.fields || [],
                pageSize: s.subscribers.limit || 15,
                writeAccess
            }

            const query = queryString.parse(location.search)
            if (query.orderby) obj.orderBy = query.orderby
            if (query.orderdir) obj.orderDir = query.orderdir
            if (query.search) obj.searchText = query.search
            if (query.segment) obj.segmentId = query.segment
            if (query.source) obj.source = query.source
            if (query.status) obj.status = query.status
            if (parseInt(query.limit)) obj.pageSize = parseInt(query.limit)
            if (parseInt(query.pagesize)) obj.pageSize = parseInt(query.pagesize)
            if (parseInt(query.offset)) obj.page = parseInt(query.offset) / obj.pageSize

            if (query.tags) {
                if (Array.isArray(query.tags)) {
                    obj.selectedTags = query.tags
                } else {
                    obj.selectedTags = [query.tags]
                }
            }

            if (query.linkTags) {
                if (Array.isArray(query.linkTags)) {
                    obj.selectedLinkTags = query.linkTags
                } else {
                    obj.selectedLinkTags = [query.linkTags]
                }
            }

            this.setState(obj, this.getAccountMaster)
        })
    }

    componentWillUnmount() {
        if (this.retryTimer) clearTimeout(this.retryTimer)
    }

    getAccountMaster() {
        axios.get('/accountMaster').then((response) => {
            this.setState(
                {
                    total: 0,
                    totalViewed: 0
                },
                this.getCustomFields
            )
        })
    }

    async getCustomFields() {
        try {
            const response = await axios.get('/customfield')
            const customFields = response.data.CustomFields.filter(
                (cf) => cf.entityType === 1 || cf.entityType === 3 || !cf.entityType
            )
            customFields.forEach((f) => {
                let found = false
                if (this.state.settings.subscribers.fields) {
                    found = this.state.settings.subscribers.fields.some((r) => r == f.id)
                } else {
                    found = f.important || false
                }
                f.selected = found
            })
            this.setState(
                {
                    customFields,
                    selectedFields: customFields.filter((f) => f.selected).map((f) => f.id)
                },
                () => {
                    this.getTags()
                    this.getSegments()
                    this.getSources()
                }
            )
        } catch (e) {
            this.getSegments()
            this.getSubscribers()
            this.getSources()
        }
    }

    async getSegments() {
        const response = await axios.get('/segment')
        let segments = response.data.Segments

        segments = segments.map((seg) => {
            seg.label = seg.name
            if (seg.readOnly || seg.readOnly == '1') {
                if (seg.label == 'Active') seg.label = i18n.t('Active')
                if (seg.label == 'In-Active') seg.label = i18n.t('In-Active')
                if (seg.label == 'Unsubscribed') seg.label = i18n.t('Unsubscribed')
                if (seg.label == 'Bounced') seg.label = i18n.t('Bounced')
                if (seg.label == 'Blacklisted') {
                    seg.label = i18n.t('Blacklisted')
                }
            }
            return seg
        })

        this.setState({
            segments: segments.filter((s) => !isNaN(s.id) || s.id === 'SMS'),
            isLoadingSegments: false
        })
    }

    async getSources() {
        const response = await axios.get('/subscriber/source/sources')
        let sources = response.data

        sources.unshift({
            name: 'All',
            source: ''
        })

        let source = this.state.source
        if (this.state.source) {
            let found = sources.find((s) => s.id == this.state.source)
            if (found) source = found.source
        }

        this.setState({
            source,
            sources: sources,
            isLoadingSources: false
        })
    }

    async getTags() {
        let tags = await axios.get(`/tags?tagType=0`)
        tags = tags.data.map((t) => {
            return {
                label: t.tagName,
                value: t.id,
                id: t.id,
                Application: t.Application,
                ApplicationId: t.ApplicationId,
                tagType: t.tagType
            }
        })
        let adTags = await axios.get(`/tags?tagType=3`)
        tags = tags.concat(
            adTags.data.map((t) => {
                return {
                    label: t.tagName,
                    value: t.id,
                    id: t.id,
                    Application: t.Application,
                    ApplicationId: t.ApplicationId,
                    tagType: t.tagType
                }
            })
        )

        tags = tags.sort((a, b) => {
            // sort by name
            return a.label.localeCompare(b.label)
        })

        tags.forEach((tag) => {
            const selected = this.firstLoad ? this.state.selectedTags.some((s) => parseInt(s) === tag.value) : false
            tag.selected = selected
        })
        this.setState({ tags: tags }, this.getLinkTags)
    }

    getLinkTags() {
        axios.get(`/tags?tagType=1`).then((data) => {
            this.setState(
                {
                    linkTags: data.data
                        .map((t) => {
                            const selected = this.firstLoad
                                ? this.state.selectedLinkTags.some((s) => parseInt(s) === t.id)
                                : false
                            return {
                                id: t.id,
                                label: t.tagName,
                                value: t.id,
                                selected
                            }
                        })
                        .sort((a, b) => {
                            // sort by name
                            return a.label.localeCompare(b.label)
                        })
                },
                this.getSubscribers
            )
            this.firstLoad = false
        })
    }

    selectTag(event) {
        let self = this
        let tags = this.state.tags
        let found = tags.find((f) => f.value == event.target.name)
        found.selected = event.target.checked
        this.setState({ tags }, () => {
            if (self.timer) clearTimeout(self.timer)
            self.timer = setTimeout(() => {
                self.changePage(0, null, null, null, null)
            }, 1000)
        })
    }

    selectLinkTag(event) {
        let self = this
        let linkTags = this.state.linkTags
        let found = linkTags.find((f) => f.value == event.target.name)
        found.selected = event.target.checked
        this.setState({ linkTags }, () => {
            if (self.timer) clearTimeout(self.timer)
            self.timer = setTimeout(() => {
                self.changePage(0, null, null, null, null)
            }, 1000)
        })
    }

    selectTags(event) {
        const value = event.target.value
        const tagId = parseInt(value.substring(2))
        if (value.indexOf('1_') === 0) {
            let index = this.state.selectedTags.indexOf(tagId)
            if (index > -1) {
                let selectedTags = [...this.state.selectedTags]
                selectedTags.splice(index, 1)
                this.setState({ selectedTags }, this.getSubscribers)
            } else {
                let selectedTags = [...this.state.selectedTags, tagId]
                this.setState({ selectedTags }, this.getSubscribers)
            }
        } else if (value.indexOf('2_') === 0) {
            let index = this.state.selectedLinkTags.indexOf(tagId)
            if (index > -1) {
                let selectedLinkTags = [...this.state.selectedLinkTags]
                selectedLinkTags.splice(index, 1)
                this.setState({ selectedLinkTags }, this.getSubscribers)
            } else {
                let selectedLinkTags = [...this.state.selectedLinkTags, tagId]
                this.setState({ selectedLinkTags }, this.getSubscribers)
            }
        }
    }

    changeSelectedFields(arr) {
        this.setState(
            {
                selectedFields: arr.filter((a) => !isNaN(a)),
                selectedSystemFields: arr.filter((a) => isNaN(a))
            },
            () => {
                const settings = this.state.settings
                settings.subscribers.systemFields = this.state.selectedSystemFields
                settings.subscribers.fields = this.state.selectedFields
                setUserSettings(settings).catch(() => {})
                this.getSubscribers()
            }
        )
    }

    getSubscribers() {
        if (this.state.isLoading) {
            this.source.cancel('I cancelled this')
            this.source = this.CancelToken.source()
        }
        var queryStr = `?limit=${this.state.pageSize}&offset=${this.state.page * this.state.pageSize}&orderby=${this.state.orderBy}&orderdir=${this.state.orderDir}&search=${encodeURIComponent(this.state.searchText)}&source=${this.state.source}&status=${this.state.status}`

        var promise

        if (history.pushState) {
            var newurl =
                window.location.protocol +
                '//' +
                window.location.host +
                window.location.pathname +
                queryStr +
                (this.state.segmentId ? '&segment=' + this.state.segmentId : '')
            const tags = this.state.tags ? this.state.tags.filter((t) => t.selected) : []
            if (tags.length) {
                newurl += `&tags=` + tags.map((t) => t.value).join('&tags=')
            }
            const linkTags = this.state.linkTags ? this.state.linkTags.filter((t) => t.selected) : []
            if (linkTags.length) {
                newurl += `&linkTags=` + linkTags.map((t) => t.value).join('&linkTags=')
            }
            window.history.pushState({ path: newurl }, '', newurl)
        }

        let selectedTags = this.state.selectedTags
        if (selectedTags.length) {
            newurl += `&tags=` + selectedTags.map((t) => t.value).join('&tags=')
            queryStr += `&tags=${selectedTags.join(',')}`
        }
        let selectedLinkTags = this.state.selectedLinkTags
        if (this.state.selectedLinkTags.length) {
            newurl += `&linkTags=` + selectedLinkTags.map((t) => t.value).join('&linkTags=')
            queryStr += `&linkTags=${selectedLinkTags.join(',')}`
        }

        queryStr += `&fields=${JSON.stringify(
            this.state.selectedFields.slice(0, SELECTED_FIELDS_LIMIT - this.state.selectedSystemFields.length)
        )}&count=true`

        if (this.state.smsFieldId && this.state.segmentId === 'SMS') {
            queryStr += '&smsFieldId=' + this.state.smsFieldId
        }

        if (this.state.segmentId) {
            promise = axios.get('/segment/' + this.state.segmentId + '/results' + queryStr, {
                cancelToken: this.source.token
            })
        } else {
            promise = axios.get('/subscriber' + queryStr, {
                cancelToken: this.source.token
            })
        }

        this.setState({
            isLoading: true,
            degraded: false,
            total: undefined
        })

        promise.then((response) => {
            const totalTags = response.data.Subscribers.reduce((a, b) => a + (b.Tags?.length || 0), 0)

            var arr = response.data.Subscribers.map((row, index) => {
                let selectedTags = []
                if (row.Tags && row.Tags.length) {
                    selectedTags = row.Tags.map((tag) => {
                        if (tag.id) return tag
                        let foundTag = this.state.tags.find((t) => t.value == tag)
                        if (foundTag) {
                            return { tagName: foundTag.label }
                        } else {
                            return ''
                        }
                    })
                }

                var finalStatus = i18n.t('Active')
                var finalStatusCol = 'square-chip-green'
                if (row.groups) {
                    var unsubbed = row.groups.filter((g) => g.unsubscribe == true)
                    var active = row.groups.filter((g) => g.active == false)
                    if (active.length) {
                        finalStatusCol = 'square-chip-orange'
                        if (active.length == row.groups.length) finalStatus = i18n.t('In-Active')
                        if (active.length < row.groups.length) finalStatus = i18n.t('InActiveInSome')
                    }
                    if (unsubbed.length) {
                        finalStatusCol = 'square-chip-red'
                        if (unsubbed.length == row.groups.length) finalStatus = i18n.t('Unsubscribed')
                        if (unsubbed.length < row.groups.length) finalStatus = i18n.t('UnsubscribedFromSome')
                    }
                }
                if (row.bounced) {
                    finalStatus = i18n.t('Bounced')
                    finalStatusCol = 'square-chip-purple'
                }
                if (row.blackListed) {
                    finalStatus = i18n.t('Blacklisted')
                    finalStatusCol = 'square-chip-black'
                }

                let source = ''
                if (row.source) {
                    const foundSource = this.state.sources.find((s) => s.source === row.source)
                    if (foundSource) {
                        source = (
                            <SquareChip
                                onClick={() => {
                                    let url = ''
                                    if (foundSource.name === 'form') {
                                        url = `/cp/forms`
                                    }
                                    if (foundSource.name === 'inbox') {
                                        url = `/cp/conversations/inbox/${row.sourceId}`
                                    }
                                    if (foundSource.name === 'social') {
                                        url = `/cp/campaigns/viewsocial/${row.sourceId}`
                                    }
                                    if (foundSource.name === 'ad') {
                                        url = `/cp/ads/campaigns/${row.sourceId}`
                                    }
                                    if (url) this.props.history.push(url)
                                }}
                            >
                                {i18n.t('subscribers:index.sources.' + foundSource.name)}
                            </SquareChip>
                        )
                    }
                }

                const important = row.customFields
                    .filter((f) => f.important)
                    .sort((a, b) => {
                        return a.fieldDesc.localeCompare(b.fieldDesc)
                    })

                var result = {
                    subscriberData: { id: row.id, order: -5 },
                    rowDeleted: { value: false, order: -4 },
                    checkBox: {
                        headerValue: this.state.writeAccess ? (
                            <CheckBox
                                outerClassName='no-marg'
                                checked={false}
                                onChange={(event) => {
                                    this.checkAll(event)
                                }}
                            />
                        ) : (
                            ''
                        ),
                        orderBy: false,
                        value: this.state.writeAccess ? (
                            <CheckBox
                                outerClassName='no-marg'
                                checked={false}
                                onChange={(event) => {
                                    this.checkBoxes(event)
                                }}
                                name={'sub' + index}
                            />
                        ) : (
                            ''
                        ),
                        isCheckBox: true,
                        width: 30,
                        isChecked: false,
                        order: -3
                    },
                    gravatar: {
                        headerValue: '',
                        value: (
                            <Avatar
                                style={{
                                    top: 3,
                                    height: 'auto',
                                    width: '100%',
                                    maxWidth: '40px',
                                    maxHeight: '40px',
                                    marginRight: '10px'
                                }}
                                src={row.accountImage}
                            />
                        ),
                        width: 50,
                        order: -2
                    },
                    emailAddress: {
                        headerValue: i18n.t('emailAddress'),
                        value: (
                            <div>
                                <Link style={{ textDecoration: 'none' }} to={'/cp/subscriber/' + row.id}>
                                    {row.emailAddress}
                                </Link>
                                {row.Organisation ? (
                                    <div>
                                        <Link
                                            className='text-sml text-grey'
                                            style={{ textDecoration: 'none' }}
                                            to={'/cp/subscribers/organisations/' + row.Organisation.id}
                                        >
                                            {row.Organisation.name}
                                        </Link>
                                    </div>
                                ) : (
                                    ''
                                )}
                            </div>
                        ),
                        orderBy: true,
                        order: -1
                    },
                    score: {
                        headerValue: i18n.t('score'),
                        value: <Score score={row.score} />,
                        orderBy: true,
                        order: 1 + important.length
                    },
                    status: {
                        headerValue: i18n.t('status'),
                        value: (
                            <SquareChip className={finalStatusCol + ' small-icon'}>
                                {finalStatus}
                            </SquareChip>
                        ),
                        order: 2 + important.length,
                        align: 'center'
                    },
                    createdAt: {
                        headerValue: i18n.t('created'),
                        value: DateTimeFunctions.formatDateTime(row.createdAt || row.addedToGroup, '2'),
                        orderBy: true,
                        width: 200,
                        order: 3 + important.length
                    },
                    updatedAt: {
                        headerValue: i18n.t('lastUpdated'),
                        value: DateTimeFunctions.formatDateTime(row.updatedAt || row.addedToGroup, '2'),
                        orderBy: true,
                        width: 200,
                        order: 4 + important.length
                    },
                    lastSendDate: {
                        headerValue: i18n.t('lastSent'),
                        value: row.lastSendDate ? DateTimeFunctions.formatDateTime(row.lastSendDate) : i18n.t('never'),
                        orderBy: true,
                        order: 5 + important.length
                    },
                    lastOpened: {
                        headerValue: i18n.t('lastOpened'),
                        value: row.lastOpened ? DateTimeFunctions.formatDateTime(row.lastOpened) : i18n.t('never'),
                        orderBy: true,
                        order: 6 + important.length
                    },
                    lastClicked: {
                        headerValue: i18n.t('lastClicked'),
                        value: row.lastClicked ? DateTimeFunctions.formatDateTime(row.lastClicked) : i18n.t('never'),
                        orderBy: true,
                        order: 7 + important.length
                    },
                    lastBounced: {
                        headerValue: i18n.t('lastBounced'),
                        value: row.lastBounced ? DateTimeFunctions.formatDateTime(row.lastBounced) : i18n.t('never'),
                        orderBy: true,
                        order: 8 + important.length
                    },
                    tags: {
                        headerValue: i18n.t('tags'),
                        value: selectedTags.map((tag) => {
                            let icon = ''
                            let text = ''
                            let color = ''
                            if (tag.tagType === 0) {
                                icon = 'person'
                                text = 'Contact Tag'
                                color = 'square-chip-primary'
                            }
                            if (tag.tagType === 1) {
                                icon = 'link'
                                text = 'Link Tag'
                                color = 'square-chip-secondary'
                            }
                            if (totalTags > 30) {
                                return (
                                    <SquareChip
                                        iconLeft={
                                            <Icons
                                                icon={icon}
                                                alt={text}
                                                title={text}
                                                color='white'
                                                style={{ height: 10, width: 10 }}
                                            />
                                        }
                                        key={'tag_' + tag.id}
                                        className={'square-chip-tag ' + color}
                                    >
                                        {tag.tagName || tag}
                                    </SquareChip>
                                )
                            } else {
                                return (
                                    <SquareChip
                                        iconLeft={
                                            <Icons
                                                icon={icon}
                                                color='white'
                                                style={{ height: 10, width: 10 }}
                                                data-tooltip-content={text}
                                                data-tooltip-id={row.id + '_tag_' + tag.id}
                                            />
                                        }
                                        key={'tag_' + tag.id}
                                        className={'square-chip-tag ' + color}
                                    >
                                        {tag.tagName || tag}
                                    </SquareChip>
                                )
                            }
                        }),
                        orderBy: false,
                        order: 9 + important.length
                    },
                    source: {
                        headerValue: i18n.t('source'),
                        value: source,
                        orderBy: true,
                        order: 10 + important.length
                    },
                    disableOpens: {
                        headerValue: i18n.t('disableOpens'),
                        value: row.disableOpens ? i18n.t('yes') : i18n.t('no'),
                        orderBy: false,
                        order: 11 + important.length
                    }
                    // disableClicks: {
                    //     headerValue: i18n.t('disableClicks'),
                    //     value: row.disableClicks ? i18n.t('yes') : i18n.t('no'),
                    //     orderBy: true,
                    //     order: 12 + important.length
                    // }
                }
                this.state.systemFields.forEach((field) => {
                    if (!this.state.selectedSystemFields.some((f) => f === field.fieldName)) {
                        delete result[field.fieldName]
                    }
                })

                important
                    .concat(
                        row.customFields
                            .filter((f) => !f.important)
                            .sort((a, b) => {
                                return a.fieldDesc.localeCompare(b.fieldDesc)
                            })
                    )
                    .forEach((field, index) => {
                        if (
                            this.state.settings?.subscribers?.fields &&
                            !this.state.settings.subscribers.fields.some((f) => f == field.id)
                        )
                            return
                        if (!Array.isArray(field.value)) {
                            field.value = [field.value]
                        }
                        field.value.forEach((value, index) => {
                            if (field.fieldType == 'BOOLEAN') {
                                field.value[index] = value ? 'Yes' : 'No'
                            } else if (value !== undefined && value !== null) {
                                if (field.fieldType == 'DATE') {
                                    field.value[index] = value ? DateTimeFunctions.formatDateTime(value, '2') : ''
                                } else if (field.fieldType == 'NUMBER') {
                                    field.value[index] = NumberFunctions.formatNumber(value)
                                } else if (
                                    (field.fieldType == 'SELECT' || field.fieldType == 'MULTISELECT') &&
                                    field.options &&
                                    field.options.length
                                ) {
                                    var option = field.options.find((o) => o.value == value)

                                    field.value[index] = option ? option.label : value
                                } else {
                                    field.value[index] = Array.isArray(value) ? value.join() : value
                                }
                            }
                        })
                        let headerValue = field.fieldDesc
                        if (field.Application) {
                            headerValue = (
                                <div className='vertical-center'>
                                    {headerValue}{' '}
                                    <Avatar
                                        style={{ height: 20, width: 20, marginLeft: 5, backgroundColor: 'white' }}
                                        for={field.id + '-App'}
                                        tooltip={field.Application.appName}
                                        src={field.Application.appLogoUri}
                                    />
                                </div>
                            )
                        }
                        result['' + field.id + ''] = {
                            headerValue,
                            value: field.value.join(', '),
                            orderBy: true,
                            width: 200,
                            order: field.important ? index : index + this.state.systemFields.length + 5
                        }
                    })
                return result
            })

            if (response.data.retry) {
                if (this.retryTimer) clearTimeout(this.retryTimer)
                this.retryTimer = setTimeout(this.getSubscribers, 1000)
            }

            this.setState({
                subscribers: this.state.loadingmore
                    ? this.state.subscribers.concat(response.data.Subscribers)
                    : response.data.Subscribers,
                loadingmore: false,
                loadingData: 0,
                degraded: response.data.degraded,
                isLoading: response.data.retry,
                retry: response.data.retry ? this.state.retry + 1 : 0,
                totalViewed: response.data.count !== undefined ? response.data.count : this.state.totalViewed,
                tableData: this.state.loadingmore ? this.state.tableData.concat(arr) : arr,
                total: response.data.count,
                allTotal: !this.state.allTotal ? response.data.count : this.state.allTotal
            })
        })
    }

    changePageSize(size) {
        const settings = this.state.settings
        settings.subscribers.limit = size
        setUserSettings(settings).catch(console.log)
        this.setState(
            {
                settings,
                page: 0,
                pageSize: size
            },
            this.getSubscribers
        )
    }

    changeSegment(segment) {
        this.setState(
            {
                segmentId: segment.id,
                page: 0
            },
            this.getSubscribers
        )
    }

    changeSource(source) {
        this.setState(
            {
                source: source.source
            },
            this.getSubscribers
        )
    }

    addSubs() {
        var drawerContent = <AddSubs history={this.props.history} />
        this.props.dispatch(siteMaster.alterSiteDrawer(true, true, 'right', drawerContent, true, 500))
    }

    changeSearchText(evt) {
        this.setState(
            {
                searchText: evt.target.value,
                page: 0
            },
            () => {
                if (this.timer) clearTimeout(this.timer)
                this.timer = setTimeout(this.getSubscribers, 250)
            }
        )
    }

    searchKeyPress() {
        this.setState(
            {
                page: 0
            },
            this.getSubscribers
        )
    }

    changePage(currentPage, sortDirection, sortColumn, pageSize, searchText) {
        if (!sortDirection) {
            sortDirection = this.state.orderDir
        }
        if (!sortColumn) {
            sortColumn = this.state.orderBy
        }
        if (!pageSize) {
            pageSize = this.state.pageSize
        }
        if (!currentPage && currentPage != '0') {
            currentPage = this.state.page
        }
        if (!searchText) {
            searchText = this.state.searchText
        }

        var startRecord = currentPage * pageSize

        this.setState(
            {
                orderBy: sortColumn,
                orderDir: sortDirection,
                pageSize: pageSize,
                page: currentPage,
                searchText: searchText,
                startRecord: startRecord
            },
            this.getSubscribers
        )
    }

    selectFields(field) {
        var self = this

        if (!field.id) {
            // its a system field
            let selectedSystemFields = this.state.selectedSystemFields
            const index = selectedSystemFields.findIndex((f) => f.fieldName === field.fieldName)
            if (index > -1) {
                selectedSystemFields.splice(index, 1)
            } else {
                selectedSystemFields.push(field)
            }
            const settings = this.state.settings
            settings.subscribers.systemFields = selectedSystemFields.map((f) => f.fieldName)
            setUserSettings(settings).catch(() => {})
            this.setState({ selectedSystemFields }, self.getSubscribers)
        } else {
            var newFields = this.state.customFields
            newFields.forEach((x) => {
                if (x.id == field.id) {
                    x.selected = !x.selected
                }
            })

            const settings = this.state.settings
            settings.subscribers.fields = newFields.filter((f) => f.selected).map((f) => f.id)
            setUserSettings(settings).catch(console.log)
            this.setState({ customfields: newFields }, self.getSubscribers)
        }
    }

    checkAll(event, forcedUntick) {
        var isChecked

        if (event) {
            isChecked = event.target.checked
        }
        if (forcedUntick && forcedUntick === true) {
            isChecked = false
        }
        //create a copy of the array with object.extend
        var newState = Object.assign([], this.state.tableData)
        for (var x in Object.keys(newState)) {
            var thisProp = newState[x]
            var checkBox = React.cloneElement(thisProp.checkBox.value, { checked: isChecked })
            var headerValue = React.cloneElement(thisProp.checkBox.headerValue, { checked: isChecked })
            thisProp.checkBox.isChecked = isChecked
            thisProp.checkBox.value = checkBox
            thisProp.checkBox.headerValue = headerValue
            newState[x] = thisProp
        }
        //write it back to state
        this.setState(
            {
                tableData: newState
            },
            this.countChecked
        )
    }

    countChecked() {
        var tickedSubs = this.state.tableData.filter((sub) => sub.checkBox.isChecked)

        var isOpen = false
        var drawerContent = <div></div>
        if (tickedSubs.length > 0) {
            isOpen = true
            drawerContent = (
                <IncGoTickSubs
                    checkAll={this.checkAll}
                    subscribers={this.state.tableData}
                    totTicked={tickedSubs.length}
                    reloadAfterTickedAndChanged={this.reloadAfterTickedAndChanged}
                />
            )
        }
        this.props.dispatch(siteMaster.alterSiteDrawer(isOpen, false, 'right', drawerContent, true))
    }
    checkBoxes(event) {
        var thisDataID = event.target.name.replace('sub', '')
        var isChecked = event.target.checked
        var newState = this.state.tableData
        var checkBox = React.cloneElement(newState[thisDataID].checkBox.value, { checked: isChecked })
        newState[thisDataID].checkBox.isChecked = isChecked
        newState[thisDataID].checkBox.value = checkBox

        this.setState(
            {
                tableData: newState
            },
            this.countChecked
        )
    }

    reloadAfterTickedAndChanged() {
        this.checkAll(null, true)
        this.getSegments()
        this.getSubscribers()
        this.getSources()
    }

    loadmore() {
        this.setState(
            {
                pageSize: this.state.mobilePageSize + this.state.tableData.length,
                currentPage: 0,
                loadingmore: true
            },
            this.getSubscribers
        )
    }

    loadmore() {
        this.setState(
            {
                currentPage: this.state.currentPage + 1,
                startRecord: this.state.tableData.length,
                loadingmore: true
            },
            this.getSubscribers
        )
    }

    filterFields(text) {
        this.setState({
            fieldsFilter: text.toLowerCase()
        })
    }

    toggleAllFields(select) {
        var self = this
        var newFields = this.state.customFields

        newFields.forEach((x) => {
            x.selected = select
        })

        const selectedSystemFields = select ? [...this.state.systemFields] : []
        const settings = this.state.settings
        settings.subscribers.fields = newFields.map((f) => f.if)
        settings.subscribers.systemFields = this.state.systemFields.map((f) => f.fieldName)
        setUserSettings(settings).catch(console.log)
        this.setState({ customfields: newFields, selectedSystemFields, settings }, self.changePage)
    }

    bulkEdit() {
        const drawer = (
            <Bulk
                onFinish={() => {
                    this.getSubscribers()
                    this.props.dispatch(siteMaster.alterSiteDrawer(false))
                }}
            />
        )
        this.props.dispatch(siteMaster.alterSiteDrawer(true, true, 'right', drawer, true, 400))
    }

    getFields() {
        if (this.state.fieldsFilter) {
            return this.state.systemFields
                .concat(this.state.customFields)
                .filter((f) => f.fieldDesc.toLowerCase().indexOf(this.state.fieldsFilter) > -1)
        } else {
            return this.state.systemFields.concat(this.state.customFields)
        }
    }

    allowSelectingAllFields(fields) {
        if (fields.length < SELECTED_FIELDS_LIMIT) return true
        return false
    }

    getSelectedFields(fields) {
        const selectedFields = fields.filter((field) => {
            if (field.id && field.selected) return field

            if (this.state.selectedSystemFields.some((f) => f.fieldName === field.fieldName)) {
                return field
            }
        })

        return selectedFields.slice(0, SELECTED_FIELDS_LIMIT)
    }

    getDisabledFieldTooltipIds(fields, selectedFields) {
        const disabledFields = fields.filter((field) => {
            const selected = selectedFields.some((f) => f === field)
            return selected === false && selectedFields.length >= SELECTED_FIELDS_LIMIT
        })
        return [...new Set(disabledFields.map((field) => field.fieldName))]
    }

    render() {
        var tags = this.state.tags
        var linkTags = this.state.linkTags

        var segments = JSON.parse(JSON.stringify(this.state.segments))
        segments.unshift({
            name: 'All',
            subscriberCount: this.state.allTotal,
            id: undefined,
            readOnly: false,
            label: i18n.t('subscribers:overview.all')
        })

        const telnoFields = this.state.customFields.filter((cf) => cf.fieldType === 'TELNO')

        return (
            <div>
                <Row>
                    <Column xs={12} sm={6} className='mar-b25'>
                        <TextInput
                            placeholder={i18n.t('subscribers:overview.searchPlaceholder')}
                            value={this.state.searchText}
                            onChange={this.changeSearchText}
                            clickToChangeClicked={this.searchKeyPress}
                            onEnterPress={this.searchKeyPress}
                            className='no-marg'
                            iconLeft={
                                <Icons
                                    icon='magnifier'
                                    style={{ height: 16, width: 16, marginTop: '1px' }}
                                    color='#2B2F41'
                                    onClick={() => {}}
                                />
                            }
                        />
                    </Column>

                    <Column xs={12} sm={6} className='end-xs mar-b25 middle-xs quickFlex'>
                        {this.state.writeAccess && (
                            <Button className='mar-r10' onClick={this.bulkEdit.bind(this)}>
                                {i18n.t('subscribers:overview.changeStatus')}
                            </Button>
                        )}
                        {this.state.writeAccess === true && (
                            <Button
                                onClick={this.addSubs}
                                className='button-primary'
                                iconLeft={<Icons icon='plus' />}
                            >
                                {i18n.t('subscribers:nav.addSubscribers')}
                            </Button>
                        )}
                    </Column>
                </Row>

                <Row className='hide-xs'>
                    <Column xs={12} sm={8} className='quickFlex mar-b25'>
                        <Select
                            outerClassName='mar-r10'
                            inlineLabel={i18n.t('subscribers:overview.segment')}
                            disabled={this.state.isLoading}
                            value={this.state.segmentId}
                            filter={true}
                            placeholderNoSelect='All'
                            autoWidth={true}
                            onChange={(e) => this.changeSegment(segments.find((s) => s.id == e.target.value))}
                            fixedHeightLarge={true}
                            data={segments.map((s) => {
                                let tmpLabel = (
                                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <div>{s.label}</div>
                                        {!!s.CapsuleId && (
                                            <SquareChip small={true} className={'square-chip-purple mar-l5'}>
                                                Capsule
                                            </SquareChip>
                                        )}
                                        {s.id === 'SMS' && (
                                            <SquareChip small={true} className={'square-chip-stone mar-l5'}>
                                                System
                                            </SquareChip>
                                        )}
                                    </div>
                                )
                                return {
                                    filter: s.label,
                                    label: tmpLabel,
                                    value: s.id,
                                    labelOverride: (
                                        <div style={{ display: 'flex' }}>
                                            <div>{s.label}</div>
                                            {s.id === this.state.segmentId && this.state.total !== undefined ? (
                                                <div className='mar-l5'>
                                                    ({NumberFunctions.formatNumber(this.state.total)})
                                                </div>
                                            ) : (
                                                ''
                                            )}
                                        </div>
                                    )
                                }
                            })}
                        />

                        {this.state.segmentId === 'SMS' && telnoFields.length > 1 && (
                            <Select
                                inlineLabel={i18n.t('subscribers:overview.smsField')}
                                outerClassName='mar-r10'
                                autoWidth={true}
                                disabled={this.state.isLoading}
                                value={this.state.smsFieldId}
                                onChange={(e) => this.setState({ smsFieldId: e.target.value }, this.getSubscribers)}
                                data={[{ label: 'Any Field', value: undefined }].concat(
                                    telnoFields.map((cf) => ({ label: cf.fieldDesc, value: cf.id }))
                                )}
                            />
                        )}

                        <Select
                            value={this.state.status}
                            inlineLabel={i18n.t('subscribers:overview.status')}
                            outerClassName='mar-r10'
                            disabled={this.state.isLoading}
                            data={[
                                {
                                    label: i18n.t('All'),
                                    value: ''
                                },
                                {
                                    label: i18n.t('Active'),
                                    value: 'active'
                                },
                                {
                                    label: i18n.t('In-Active'),
                                    value: 'in-active'
                                },
                                {
                                    label: i18n.t('Unsubscribed'),
                                    value: 'unsubscribed'
                                },
                                {
                                    label: i18n.t('Blacklisted'),
                                    value: 'blacklisted'
                                },
                                {
                                    label: i18n.t('Bounced'),
                                    value: 'bounce'
                                }
                            ]}
                            onChange={(e) => this.setState({ status: e.target.value }, this.getSubscribers)}
                        />

                        <Select
                            inlineLabel={i18n.t('subscribers:overview.tags')}
                            outerClassName='mar-r10'
                            placeholderNoSelect={i18n.t('All')}
                            disabled={this.state.isLoading}
                            multiple={true}
                            filter={true}
                            fixedHeightLarge={true}
                            autoWidth={true}
                            value={[
                                ...this.state.selectedTags.map((tag) => '1_' + tag),
                                ...this.state.selectedLinkTags.map((tag) => '2_' + tag)
                            ]}
                            onChange={this.selectTags}
                            data={tags
                                .map((tag) => {
                                    let type = i18n.t('subscribers:overview.tagsContact')
                                    if (tag.tagType === 3) type = i18n.t('subscribers:overview.tagsTracker')
                                    return {
                                        label: tag.label,
                                        value: '1_' + tag.id,
                                        group: type
                                    }
                                })
                                .concat(
                                    linkTags.map((tag) => {
                                        return {
                                            label: tag.label,
                                            value: '2_' + tag.id,
                                            group: i18n.t('subscribers:overview.tagsLink')
                                        }
                                    })
                                )}
                        />

                        <Select
                            outerClassName='mar-r10'
                            inlineLabel={i18n.t('subscribers:overview.source')}
                            disabled={this.state.isLoading}
                            value={this.state.source}
                            placeholderNoSelect='All'
                            autoWidth={true}
                            onChange={(e) =>
                                this.changeSource(this.state.sources.find((s) => s.source == e.target.value))
                            }
                            fixedHeightLarge={true}
                            data={this.state.sources.map((s) => {
                                return {
                                    label: i18n.t('subscribers:overview.sources.' + s.name),
                                    value: s.source
                                }
                            })}
                        />
                    </Column>

                    <Column
                        xs={12}
                        sm={4}
                        className='hide-xs end-xs mar-b25'
                        style={{ display: 'flex', alignItems: 'center' }}
                    >
                        <Select
                            align='right'
                            outerClassName='mar-r5'
                            inlineLabel={i18n.t('subscribers:overview.perPage')}
                            value={this.state.pageSize}
                            data={[15, 50, 100, 250, 500]}
                            onChange={(e) => this.changePageSize(e.target.value)}
                        />
                        <ColumnSelect
                            data={[
                                ...this.state.systemFields.map((sf) => ({
                                    label: sf.fieldDesc,
                                    value: sf.fieldName,
                                    group: i18n.t('subscribers:overview.systemFields')
                                })),
                                ...this.state.customFields.map((cf) => ({
                                    label: cf.fieldDesc,
                                    value: cf.id,
                                    group: i18n.t('subscribers:overview.customFields', { SELECTED_FIELDS_LIMIT }),
                                    disabled:
                                        this.state.selectedFields.length >= SELECTED_FIELDS_LIMIT &&
                                        !this.state.selectedFields.some((f) => f === cf.id),
                                    iconRight:
                                        this.state.customFields.length > 100 ? undefined : cf.Application?.appLogoUri,
                                    iconRightTooltip:
                                        this.state.customFields.length > 100 ? undefined : cf.Application?.appName
                                }))
                            ]}
                            value={[...this.state.selectedFields, ...this.state.selectedSystemFields]}
                            onChange={this.changeSelectedFields}
                        />
                    </Column>
                </Row>

                <DataTable1
                    noResultsTxt={<span className='hide-xs'> {i18n.t('subscribers:overview.noSubscribers')} </span>}
                    tableData={this.state.tableData}
                    dataUpdater={this.changePage}
                    loadingData={this.state.loadingData}
                    sortedColumn={this.state.orderBy}
                    sortedDirection={this.state.orderDir}
                    width='100%'
                    changeColumnOrder={true}
                    pageSize={this.state.pageSize}
                    isLoading={this.state.isLoading}
                    hasCheckBoxes={
                        PermissionChecker('subscribers', this.props.permissionStore.permissions, 'write')
                            ? 'multi'
                            : false
                    }
                />

                <Row>
                    <Column xs={12} hide={['xs', 'sm']} className='center-xs mar-t25'>
                        <PagingBlock
                            totalRows={this.state.totalViewed}
                            pageSize={this.state.pageSize}
                            numberOfLinks='10'
                            currentPage={this.state.page}
                            changePage={this.changePage}
                            text={i18n.t('page') + ':'}
                        />
                    </Column>
                    {this.state.tableData.length < this.state.totalViewed && (
                        <Column xs={12} hide={['md', 'lg']} className='center-xs'>
                            <Button
                                className={'outline button-md primary ' + (this.state.loadingmore ? 'loading' : '')}
                                text={this.state.loadingmore ? 'loading' : 'load more'}
                                onClick={this.loadmore}
                            />
                        </Column>
                    )}
                </Row>

                <SnackBar
                    message={i18n.t('subscribers:index.resync')}
                    open={this.state.retry > 2}
                    autoCloseDuration={5000}
                    autoclose={true}
                    dismiss={() => this.setState({ retry: 0 })}
                />
                <SnackBar
                    message={i18n.t('subscribers:index.degraded')}
                    open={this.state.degraded}
                    autoCloseDuration={5000}
                    autoclose={true}
                    dismiss={() => this.setState({ degraded: false })}
                />
            </div>
        )
    }
}
